'use client'
import { useEffect } from 'react'
import { usePathname, useRouter } from 'next/navigation'
import { getCurrentUser } from 'aws-amplify/auth'
import { configureAmplifyClient } from '@/lib/amplify-client'
import { ThemeProvider } from '@/lib/theme-provider'

export default function Providers({ children }: { children: React.ReactNode }) {
  const router = useRouter()
  const pathname = usePathname()

  useEffect(() => {
    configureAmplifyClient()
  }, [])

  useEffect(() => {
    let isMounted = true
    async function ensureAuthenticated() {
      // Allow unauthenticated access to auth routes and documentation
      if (pathname?.startsWith('/signin') || 
          pathname?.startsWith('/signup') || 
          pathname?.startsWith('/verify-email') || 
          pathname?.startsWith('/forgot-password') || 
          pathname?.startsWith('/reset-password') || 
          pathname?.startsWith('/documentation') || 
          pathname === '/') return
      try {
        await getCurrentUser()
      } catch {
        if (!isMounted) return
        router.replace('/signin')
      }
    }
    ensureAuthenticated()
    return () => {
      isMounted = false
    }
  }, [pathname, router])
  
  return (
    <ThemeProvider defaultTheme="system" storageKey="dlom-theme">
      {children as React.ReactElement}
    </ThemeProvider>
  )
}


